import { marked } from 'marked';
import DOMPurify from 'dompurify';

const renderer = new marked.Renderer();

renderer.code = function(code, lang) {
    let codeStr = '';
    let language = lang;
    if (typeof code === 'object' && code !== null) {
        codeStr = String(code.text || '');
        language = code.lang || language;
    } else {
        codeStr = String(code || '');
    }
    let highlighted = codeStr;
    if (window.hljs && language && typeof language === 'string') {
        try {
            if (window.hljs.getLanguage(language)) {
                let result;
                try { result = window.hljs.highlight(codeStr, { language }); }
                catch { try { result = window.hljs.highlight(language, codeStr); } catch {} }
                if (result) {
                    highlighted = typeof result === 'object' && result.value ? String(result.value)
                        : typeof result === 'string' ? result : String(codeStr);
                }
            }
        } catch (e) { console.warn('Highlighting failed:', e); }
    }
    if (typeof highlighted !== 'string') highlighted = String(codeStr);
    const isSecure = window.location.protocol === 'https:';
    const actionBtnClass = isSecure ? 'btn-copy-code' : 'btn-select-all';
    const actionBtnText  = isSecure ? '복사' : '전체 선택';
    return `
    <div class="code-block-container open">
        <div class="code-header">
            <span class="lang-label">${language || 'text'}</span>
            <div class="code-controls">
                <button type="button" class="${actionBtnClass}">${actionBtnText}</button>
                <button type="button" class="btn-toggle-code">접기</button>
            </div>
        </div>
        <div class="code-content-wrapper">
            <div class="code-content-inner">
                <pre><code class="hljs ${language || ''}">${highlighted}</code></pre>
            </div>
        </div>
    </div>`;
};

marked.setOptions({ breaks: true, gfm: true, renderer });

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if ('target' in node) {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener noreferrer');
    }
});

export { marked, DOMPurify };
